import { render, staticRenderFns } from "./BillReport.vue?vue&type=template&id=0cc7d847&scoped=true&"
import script from "./BillReport.vue?vue&type=script&lang=js&"
export * from "./BillReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc7d847",
  null
  
)

export default component.exports